<style scoped lang="scss">
.progressive-image-wrapper {
  position: relative;

  img {
    max-width: 100%;
    margin: auto;
  }

  .main-image {}

  .placeholder-image {
    // filter: blur(3px);
  }

  .progressive-image {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
  }
}
</style>

<template>
  <div class="progressive-image-wrapper">
    <div class="progressive-image" :style="{ height: maxHeight + 'px' }">
      <img ref="mainImage" :src="src" class="main-image" @load="onload" alt=""
        :style="{ 'max-height': maxHeight + 'px' }">
    </div>
    <div class="progressive-image" v-show="showPlaceholder" :style="{ height: maxHeight + 'px' }">
      <img ref="placeholderImage" :src="placeholder" class="placeholder-image" alt=""
        :style="{ 'max-height': maxHeight + 'px' }">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxHeight: {
      type: Number
    }
  },
  mounted: function () {

  },
  data() {
    return {
      // mainImageHeight: "0px"
      // showMain: false
      showPlaceholder: true
    };
  },
  computed: {
    mainImage() {
      return this.$refs.mainImage;
    }
  },
  watch: {},
  methods: {
    onload() {
      // this.mainImageHeight
      this.showPlaceholder = false;
      // this.showMain = true;
    }
  }
};
</script>
